/* global G */
import { modelComposition } from 'trait/composition'
import { pipe } from 'lib/util'
import { withGetterSetter } from 'trait/with'
import { usesGetterSetter } from 'trait/uses'
import toBoolean from 'model/_shared/transformer/toBoolean'
import validator from './validator/pairing'

const descriptor = 'model::xEcoApm::pairing'

export default pipe(
  modelComposition(descriptor),
  withGetterSetter(G.VALIDATOR),
  usesGetterSetter(G.VALIDATOR, validator),
  usesGetterSetter(G.TRANSFORMER, {
    licenceUpload: toBoolean('licenceUpload'),
  }),
)
